import React from "react";
import { Divider, Grid } from "@mui/material";
import { InputButton, LoadingButton } from "components/UI";
//UTIL
import { findObject, isBlankOrNull, messageDisplay, responseErrors } from "utils";

//Type
import { BUTTON_VALUE } from "shared/constants";
import { MSG_TYPE, ModeAction } from "state/enum";
import { formatRowWareHouseSummary, simulateGraph } from "../hooks/format";
import { DEFAULT_WAREHOUSE_SUMMARY } from "../constants/constant";
//Service
import {
  useWareHouseSummarySearchTableMutation,
  useWareHouseSummarySearchGraphMutation,
  useWareHouseSummaryGenerateGraphMutation,
  useWareHouseSummaryStatusGenerateGraphMutation,
} from "shared/services/inventory";
import { ResponseText } from "utils/5xxResponseText";
import { deepClone } from "@mui/x-data-grid/utils/utils";
import { useSelector } from "react-redux";

export default function ButtonCriterial(props) {
  const {
    form,
    setForm,
    rows,
    setRows,
    rPkg,
    setRPkg,
    graphData,
    setGraph,
    defaultGraphData,
    setDefaultGraph,
    defaultRows,
    setDefaultRows,
    setMode,
    onSearch,
    setOnSearch,
    getWarehouse,
    setOpenGraph,
    setViewBtn,
    loadingView: { isLoadingView, setIsLoadingView },
    stateBtn: { searchBtn, clearBtn, editBtn, viewBtn, setGeneratedGraph, generatedGraph },
    setMsg: { setMsgAlert, setMsgError },
    loading: { startLoading, stopLoading },
    dataList: { rPackageOwnerList, rPackageTypeList },
    rowSelection: { setRowModesModel, setRowSelectionModel },
    functionId,
    setAppId,
    appId,
  } = props;
  let state;
  const searchTable = useWareHouseSummarySearchTableMutation();
  const searchGraph = useWareHouseSummarySearchGraphMutation();
  const generateGraph = useWareHouseSummaryGenerateGraphMutation();
  const statusGraph = useWareHouseSummaryStatusGenerateGraphMutation();
  const userInfo = useSelector(state => state.auth.user);

  const getGraph = async appId => {
    try {
      const bodySearch = {
        dataOwner: form?.dataOwner,
        rPkgOwner: !form?.rPackageOwnerId
          ? ""
          : findObject({
              data: rPackageOwnerList,
              value: form?.rPackageOwnerId,
              property: "rPkgOwnerCompId",
              field: "rPkgOwnerCompAbbr",
            }),
        rPkgType: !form?.rPackageTypeId
          ? ""
          : findObject({
              data: rPackageTypeList,
              value: form?.rPackageTypeId,
              property: "rPkgTypeId",
              field: "rPkgType",
            }),
        location: getWarehouse(form?.wareHouseId),
      };
      // startLoading();
      const data = await searchGraph(bodySearch, { appId: appId });
      // stopLoading();
      return data;
    } catch (error) {
      throw error;
    }
  };
  const checkStatusBatch = (limit, response) => {
    // 60 sec * n min
    const timer = 2;
    let count = 0;
    const { appId } = response;

    state = setInterval(async () => {
      count += timer;
      try {
        if (count >= limit) {
          clearInterval(state);
          setIsLoadingView(false);
          console.error("TimeOut");
          setMsgError([ResponseText[504]]);
          throw new Error("TimeOut");
        }
      } catch (error) {
        clearInterval(state);
        setIsLoadingView(false);
        console.error("An error occurred while checking the generate graph:", error);
        setMsgError(prev => [
          ...prev,
          [
            messageDisplay({
              type: MSG_TYPE.ERROR,
              code: "MSTD0067AERR",
              msg: ["Daily Inventory Simulation Batch process is error"],
            }),
          ],
        ]);
      }

      try {
        const response = await statusGraph({ appId: appId });
        const { status, isHasData } = response;
        if (status === "success") {
          clearInterval(state);
          setIsLoadingView(false);
          if (!isHasData) {
            setViewBtn(true);
            setGeneratedGraph(true);
            return true;
          }
          setGraph({});
          setDefaultGraph({});
          const data = await getGraph(appId);
          const { result } = data;

          if (isBlankOrNull(result)) {
            setMsgError(["MSTD0061AERR: No data to be displayed graph"]);
            setGraph({});
            setDefaultGraph({});
            setOpenGraph(false);
            return;
          }
          // console.log("response get graph ", data);

          console.log("start simulateGraph: ", new Date());
          const simulateData = simulateGraph(result, rows, rPkg, true);

          console.log("end simulateGraph: ", new Date());
          console.log("result format", simulateData);

          setGraph(simulateData);
          setDefaultGraph(simulateData);
          return true;
        } else if (status === "error") {
          clearInterval(state);
          setIsLoadingView(false);
          setMsgError(prev => [
            ...prev,
            [
              messageDisplay({
                type: MSG_TYPE.ERROR,
                code: "MSTD0067AERR",
                msg: ["Daily Inventory Simulation Batch process is error"],
              }),
            ],
          ]);
          return false;
        }
      } catch (error) {
        clearInterval(state);
        console.error("An error occurred while checking the generate graph:", error);
        setMsgError([error]);
        const { response } = error;
        return response;
      }
    }, timer * 1000);
  };
  const checkGraph = async bodySearch => {
    try {
      const response = await generateGraph({
        dataOwner: bodySearch?.dataOwner,
        rPkgOwner: bodySearch?.rPkgOwner,
        location: bodySearch?.warehouse,
        rPkgType: bodySearch?.rPkgType,
      });

      if (!response) {
        setIsLoadingView(false);
        setViewBtn(true);
        setGeneratedGraph(true);
        setMsgError(prev => [
          ...prev,
          [
            messageDisplay({
              type: MSG_TYPE.ERROR,
              code: "MSTD0067AERR",
              msg: ["Daily Inventory Simulation Batch process is error"],
            }),
          ],
        ]);
        return;
      }
      setIsLoadingView(true);
      // 60 sec * 10 min
      checkStatusBatch(600, response);
      setAppId(response.appId);
    } catch (error) {
      console.error(error);
    }
  };
  const handleView = async e => {
    try {
      e.preventDefault();

      setMode(ModeAction.VIEW);
      setMsgError([]);
      setMsgAlert([]);
      if (!isBlankOrNull(graphData)) {
        setOpenGraph(true);
        return;
      }

      setMsgError(["MSTD0061AERR: No data to be displayed graph"]);
      setGraph({});
      setDefaultGraph({});
      setOpenGraph(false);

      // const data = await getGraph(appId);
      // if (isBlankOrNull(data?.result?.data)) {
      //   setGraph({});
      //   setDefaultGraph({});
      //   setOpenGraph(false);
      //   setOnSearch(true);
      // }
      // const { result } = data;
      // const simulateData = simulateGraph(result, rows, rPkg, true);

      // setGraph(simulateData);
      // setDefaultGraph(data);
      // setOpenGraph(true);
      // setOnSearch(true);
      return;
    } catch (error) {
      if (error?.statusCode === 500) {
        return setMsgError([error?.message]);
      }
      const errors = responseErrors(error);
      setMsgError(errors);
      stopLoading();
      return;
    }
  };
  const handleSearch = async e => {
    try {
      e.preventDefault();
      setMsgError([]);
      setMsgAlert([]);
      setGraph({});
      setDefaultGraph({});
      // Reset Data of Table
      setOnSearch(false);
      setMode("Initial");
      setRowSelectionModel([]);
      setRowModesModel({});
      setRows([]);
      setDefaultRows([]);
      clearInterval(state);
      state = 0;
      const bodySearch = {
        dataOwner: form?.dataOwner,
        rPkgOwner: !form?.rPackageOwnerId
          ? ""
          : findObject({
              data: rPackageOwnerList,
              value: form?.rPackageOwnerId,
              property: "rPkgOwnerCompId",
              field: "rPkgOwnerCompAbbr",
            }),
        rPkgType: !form?.rPackageTypeId
          ? ""
          : findObject({
              data: rPackageTypeList,
              value: form?.rPackageTypeId,
              property: "rPkgTypeId",
              field: "rPkgType",
            }),
        warehouse: getWarehouse(form.wareHouseId),
      };

      startLoading();
      const searchData = await searchTable(bodySearch);
      stopLoading();

      if (!searchData?.result?.length) {
        setMsgError([
          messageDisplay({
            type: MSG_TYPE.ERROR,
            code: "MSTD0059AERR",
            msg: "",
          }),
        ]);
        return;
      }
      // check status
      checkGraph(bodySearch);
      const { data, rPkg } = formatRowWareHouseSummary(searchData?.result);
      setRows(deepClone(data));
      setDefaultRows(deepClone(data));
      setRPkg(rPkg);
      setMode(ModeAction.VIEW);
      setOnSearch(true);
    } catch (error) {
      const errors = responseErrors(error);
      setMsgError(errors);
      stopLoading();
      return;
    }
  };
  const handleClear = async () => {
    setMsgError([]);
    setMsgAlert([]);
    // reset form
    setForm({ ...DEFAULT_WAREHOUSE_SUMMARY, userId: userInfo.userName });
    setMode("Initial");
    setOnSearch(false);
    setGraph({});
    setDefaultGraph({});

    setRowModesModel({});
    setRowSelectionModel([]);
    setRows([]);
    setDefaultRows([]);
    setRPkg([]);
    setGeneratedGraph(false);
    setIsLoadingView(false);
  };
  const handleEdit = async () => {
    try {
      setMsgError([]);
      setMsgAlert([]);
      //tiger table mode edit
      setMode(ModeAction.EDIT);

      return;
    } catch (error) {
      console.error(error);
      const errors = responseErrors(error);
      setMsgError(errors);
      return;
    }
  };
  return (
    <Grid item sx={{ m: "2px 0" }}>
      <Grid item xs={4} sx={{ display: "flex", justifyContent: "flex-end", mt: 2, mb: 2 }}>
        <LoadingButton
          id="button-view"
          value={BUTTON_VALUE.VIEW}
          onClick={handleView}
          disabled={generatedGraph || viewBtn}
          loading={isLoadingView}
          name={`${functionId}Search`}
          tabIndex={1}
        />
        {/* <InputButton id="button-view" value={BUTTON_VALUE.VIEW} onClick={handleView} disabled={viewBtn} /> */}
        <LoadingButton
          id="button-search"
          value={BUTTON_VALUE.SEARCH}
          onClick={handleSearch}
          disabled={searchBtn}
          loading={isLoadingView}
          name={`${functionId}Search`}
          tabIndex={1}
        />
        {/* <InputButton id="button-search" value={BUTTON_VALUE.SEARCH} onClick={handleSearch} disabled={searchBtn} /> */}
        <InputButton
          id="button-clear"
          value={BUTTON_VALUE.CLEAR}
          onClick={handleClear}
          disabled={clearBtn}
          onKeyDown={e => {
            if (!onSearch && e.key === "Tab") {
              e.preventDefault();
              document.getElementById("select-rPkg-owner").focus();
            }
          }}
          tabIndex={1}
          name={`${functionId}Clear`}
        />
        <InputButton
          id="button-edit"
          value={BUTTON_VALUE.EDIT}
          onClick={handleEdit}
          disabled={editBtn}
          onKeyDown={e => {
            if (onSearch && e.key === "Tab") {
              e.preventDefault();
              document.getElementById("select-rPkg-owner").focus();
            }
          }}
          tabIndex={1}
          name={`${functionId}Edit`}
        />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </Grid>
  );
}
